import React from 'react';
import PropTypes from 'prop-types';

class InputFechaV3 extends React.Component {
    constructor(props) {
        super(props);
        const valorReal = props.valor || '';
        console.log("valorReal:", valorReal);


        const digits = this.onlyDigits(valorReal);
        this.state = {
            raw: digits,
            formatted: this.formatFromDigits(digits),
            error: null,
        };
        this.inputRef = React.createRef();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.valor !== this.props.valor) {
            const valorReal = this.props.valor || '';
            const digits = this.onlyDigits(valorReal);
            this.setState({
                raw: digits,
                formatted: this.formatFromDigits(digits),
                error: null,
            });
        }
    }

    onlyDigits = (str) => (str || '').replace(/\D/g, '');

    formatFromDigits = (digits) => {
        const m = digits.match(/^(\d{0,2})(\d{0,2})(\d{0,4})$/);
        if (!m) return '';
        const [_, d, mth, y] = m;
        if (!mth) return d;
        if (!y) return `${d}/${mth}`;
        return `${d}/${mth}/${y}`;
    };

    expandYear = (formatted) => {
        const { autocompletarAgno } = this.props;
        if (!autocompletarAgno) return formatted;
        const parts = formatted.split('/');
        if (parts.length !== 3) return formatted;
        let [dd, mm, yyyy] = parts;
        if (yyyy.length === 2) {
            const yNum = parseInt(yyyy, 10);
            yyyy = yNum <= 30 ? `20${yyyy}` : `19${yyyy}`;
        }
        return `${dd}/${mm}/${yyyy}`;
    };

    validateDate = (formatted) => {
        if (!formatted || formatted.trim() === '') return { valid: false, message: 'La fecha está vacía' };
        const parts = formatted.split('/');
        if (parts.length !== 3) return { valid: false, message: 'Formato debe ser dd/mm/yyyy' };
        const [ddS, mmS, yyyyS] = parts;
        if (!(ddS.length === 2 && mmS.length === 2 && (yyyyS.length === 2 || yyyyS.length === 4))) {
            return { valid: false, message: 'Formato dd/mm/aaaa (ej. 08/09/2025)' };
        }
        const day = parseInt(ddS, 10);
        const month = parseInt(mmS, 10);
        let year = parseInt(yyyyS, 10);
        if (yyyyS.length === 2) year += (year <= 30 ? 2000 : 1900);

        if (isNaN(day) || isNaN(month) || isNaN(year)) return { valid: false, message: 'Partes no numéricas' };
        if (year < 1900 || year > 9999) return { valid: false, message: 'Año fuera de rango (1900-9999)' };
        if (month < 1 || month > 12) return { valid: false, message: 'Mes debe estar entre 01 y 12' };
        const daysInMonth = new Date(year, month, 0).getDate();
        if (day < 1 || day > daysInMonth) return { valid: false, message: `Día inválido para el mes: máximo ${daysInMonth}` };
        return { valid: true, message: null };
    };

    handleChange = (e) => {
        const { onChange } = this.props;
        const input = e.target.value;
        const digits = this.onlyDigits(input).slice(0, 8);
        const formatted = this.formatFromDigits(digits);
        this.setState({ raw: digits, formatted, error: null }, () => {
            const resultado = this.validateDate(formatted);
            if (resultado.valid) {
                const finalFormatted = this.expandYear(formatted);
                //onChange && onChange(finalFormatted);
                const isoDate = this.formattedToISO(finalFormatted); // <-- yyyy-mm-dd
                onChange && onChange(isoDate);

            }
        });
    };

    handleBlur = () => {
        const { formatted } = this.state;
        const resultado = this.validateDate(formatted);
        this.setState({ error: resultado.valid ? null : resultado.message });
    };

    handleKeyDown = (e) => {
        const allowedControl = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
        if (allowedControl.includes(e.key)) return;
        if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) return;
        if (!/^[0-9/]$/.test(e.key)) e.preventDefault();
    };

    handlePaste = (e) => {
        e.preventDefault();
        const text = (e.clipboardData || window.clipboardData).getData('text');
        const digits = this.onlyDigits(text).slice(0, 8);
        const newDigits = (this.state.raw + digits).slice(0, 8);
        const formatted = this.formatFromDigits(newDigits);
        this.setState({ raw: newDigits, formatted, error: null }, () => {
            const resultado = this.validateDate(formatted);
            if (resultado.valid) {
                const finalFormatted = this.expandYear(formatted);
                //this.props.onChange && this.props.onChange(finalFormatted);
                const isoDate = this.formattedToISO(finalFormatted); // <-- yyyy-mm-dd
                this.props.onChange && this.props.onChange(isoDate);
            }
        });
    };

    toTimestamp = (formatted) => {
        if (!formatted) return null;
        const [dd, mm, yyyy] = formatted.split('/');
        if (!dd || !mm || !yyyy) return null;
        const date = new Date(parseInt(yyyy, 10), parseInt(mm, 10) - 1, parseInt(dd, 10));
        return date.getTime();
    };

    formattedToISO = (formatted) => {
        if (!formatted)
            return null;
        const [dd, mm, yyyy] = formatted.split('/');
        if (!dd || !mm || !yyyy)
            return null;
        return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
    };

    render() {
        const { formatted, error } = this.state;
        const { disabled, className } = this.props;

        return (
            <div className={className || 'w-full max-w-sm'}>
                <div className="flex items-center gap-2">
                    <input
                        ref={this.inputRef}
                        type="text"
                        inputMode="numeric"
                        placeholder="dd/mm/yyyy"
                        value={formatted}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        onKeyDown={this.handleKeyDown}
                        onPaste={this.handlePaste}
                        disabled={disabled}
                        maxLength={10}
                        className={`border rounded px-3 py-2 text-sm w-full ${error ? 'border-red-500' : 'border-gray-300'}`}
                        aria-invalid={!!error}
                        aria-describedby={error ? 'date-error' : undefined}
                    />
                </div>
                {error && <p id="date-error" className="text-red-600 text-sm mt-1">{error}</p>}
            </div>
        );
    }
}

InputFechaV3.propTypes = {
    className: PropTypes.string,
    valor: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    autocompletarAgno: PropTypes.bool, // nuevo parámetro
};

InputFechaV3.defaultProps = {
    autocompletarAgno: true,
};

export default InputFechaV3;
